import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  lazy,
  Suspense,
} from 'react';
import {
  Box,
  Button,
  Input,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Flex,
  Select,
  Text,
  Grid,
  useToast,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Spinner,
  HStack,
  Checkbox,
} from '@chakra-ui/react';
import { Bar } from 'react-chartjs-2';
import { Menu, MenuButton, MenuList, MenuItem } from '@chakra-ui/react';
import { AddIcon, ChevronDownIcon } from '@chakra-ui/icons';
import * as XLSX from 'xlsx';
import axios from 'axios';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
} from 'chart.js';
import TransaccionDetails from 'views/Pagos/DetallePagos';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import LoadingOverlay from 'components/cargando/loading';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  ChartDataLabels,
);

const CajaGeneral = lazy(() => import('../Facturacion/CajaGeneral')); // Lazy load del componente

interface ConceptoTransaccion {
  ID: number;
  HistorialID: number;
  ClaveProdServ: string;
  ClaveUnidad: string;
  Cantidad: number;
  NoIdentificacion: string;
  Unidad: string;
  Descripcion: string;
  ValorUnitario: number;
  Importe: number;
  ObjImp: string | null;
  ObjetoImp: string | null;
  Descuento: number | null;
  TipoDescuento: string | null;
  ConceptoId: number | null;
  Concepto: string | null;
}

interface Transaccion {
  usuario: string;
  ID: number;
  Concepto: string;
  RazonSocial: string;
  MetodoPago: string;
  Monto: number | null;
  UUID: string;
  RFCReceptor: string;
  estatus_de_cancelacion: string;
  Fecha: string;
  IDTransacc: string;
  ConceptosTransacciones: ConceptoTransaccion[]; // Array de conceptos dentro de la transacción
}


const HistorialTransacciones: React.FC = () => {
  const user = useSelector((state: RootState) => state.auth.user);
  const [isLoading, setIsLoading] = useState(false);

  //const userProfile = user?.rol || 'guest'; // Perfil del usuario actual
  const [FilteredTransactions, setFilteredTransactions] = useState<
    Transaccion[]
  >([]);

  const today = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }); // Ejemplo: "December 7, 2024"
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1); // Sumar 1 día
  const formattedTomorrow = tomorrow.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  //const [estatusFilter, setEstatusFilter] = useState(false);
  const [estatusFilter, setEstatusFilter] = useState('TODOS'); // Estado del filtro

  const [razonSocialFilterx, setRazonSocialFilterx] = useState('');
  const [usuarioFilterx, setusuarioFilterx] = useState('');

  const [transactions, setTransactions] = useState<Transaccion[]>([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10000);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [conceptoFilter, setConceptoFilter] = useState('');
  const [razonSocialFilter, setRazonSocialFilter] = useState('');
  const [metodoPagoFilter, setMetodoPagoFilter] = useState('');
  const [startDate, setStartDate] = useState(today);
  const [loading, setLoading] = useState(false); // Estado para bloquear pantalla

  const [endDate, setEndDate] = useState(formattedTomorrow);

  const [selectedTransaction, setSelectedTransaction] =
    useState<Transaccion | null>(null);

  const toast = useToast();
  const {
    isOpen: isModalOpen,
    onOpen: onModalOpen,
    onClose: onModalClose,
  } = useDisclosure();
  const {
    isOpen: isDetailOpen,
    onOpen: onDetailOpen,
    onClose: onDetailClose,
  } = useDisclosure();

  const fetchTransactions = useCallback(async () => {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString(),
        search: searchTerm,
        concepto: conceptoFilter,
        razonSocial: razonSocialFilter,
        metodoPago: metodoPagoFilter,
        startDate,
        endDate,
      });
      setIsLoading(true);

      const response = await fetch(
        `http://52.91.130.91:5000/api/Transacciones/TConceptos?${params.toString()}`,
      );
      const data = await response.json();
      //const data = await response.json();
      // const filteredData = data.data.filter(
      //   (transaction: Transaccion) => transaction.Concepto === 'AGUA POTABLE',
      // );
      //setTransactions(filteredData);
      setTransactions(data.data);
      setTotalPages(data.pagination.totalPages);
      setIsLoading(false);

    } catch (error) {
      toast({
        title: 'Error',
        description: 'No se pudieron cargar los datos de las transacciones.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  }, [
    page,
    pageSize,
    searchTerm,
    conceptoFilter,
    razonSocialFilter,
    metodoPagoFilter,
    startDate,
    endDate,
  ]);

  useEffect(() => {
    fetchTransactions();
  }, []);

  useEffect(() => {
    const filteredData = transactions
        .map((transaction) => {
            // Filtrar solo los conceptos que contienen la palabra clave
            const filteredConcepts = transaction.ConceptosTransacciones.filter((concepto: any) =>
                concepto.Descripcion.toLowerCase().includes(razonSocialFilterx.toLowerCase())
            );

            // Si hay coincidencias, mantener la transacción pero con los conceptos filtrados
            const matchesRazonSocial = filteredConcepts.length > 0;

            const matchesUsuario = transaction.IDTransacc
                .toLowerCase()
                .includes(usuarioFilterx.toLowerCase());

            const matchesEstatus =
                estatusFilter === 'TODOS'
                    ? true
                    : estatusFilter === 'CANCELADO'
                    ? transaction.estatus_de_cancelacion === 'CANCELADO'
                    : estatusFilter === 'TIMBRADOS'
                    ? transaction.estatus_de_cancelacion !== 'CANCELADO'
                    : true;

            const matchesAreaConcepto =
                conceptoFilter === 'TODOS'
                    ? true
                    : conceptoFilter === 'PREDIAL'
                    ? transaction.Concepto === 'PREDIAL'
                    : conceptoFilter === 'AGUA POTABLE'
                    ? transaction.Concepto === 'AGUA POTABLE'
                    : conceptoFilter === 'GENERAL'
                    ? transaction.Concepto === 'GENERAL'
                    : true;

            // Si la transacción cumple con los filtros, devolverla con los conceptos filtrados
            return matchesRazonSocial && matchesUsuario && matchesEstatus && matchesAreaConcepto
                ? { ...transaction, ConceptosTransacciones: filteredConcepts }
                : null;
        })
        .filter(Boolean); // Filtrar los `null`, para eliminar transacciones sin coincidencias

    setFilteredTransactions(filteredData);
}, [razonSocialFilterx, usuarioFilterx, estatusFilter, conceptoFilter, transactions]);

  const applyFilters = useCallback(() => {
    setPage(1); // Reiniciar a la primera página al aplicar filtros
    fetchTransactions();
  }, [fetchTransactions]);

  const paginatedTransactions = useMemo(() => {
    const startIndex = (page - 1) * pageSize;
    return transactions.slice(startIndex, startIndex + pageSize);
  }, [page, pageSize, transactions]);

  const groupedData = useMemo(() => {
    return FilteredTransactions.reduce((acc, transaction) => {
      if (transaction.Concepto in acc) {
        acc[transaction.Concepto] += transaction.Monto || 0;
      } else {
        acc[transaction.Concepto] = transaction.Monto || 0;
      }
      return acc;
    }, {} as Record<string, number>);
  }, [FilteredTransactions]);

  const chartOptions = useMemo(
    () => ({
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        datalabels: {
          formatter: (value: number) => `$${value.toFixed(2)}`,
          font: {
            size: 12,
          },
          color: 'black',
        },
      },
    }),
    [],
  );

  const totalImporte = useMemo(() => {
    return FilteredTransactions.flatMap((transaction: any) =>
      transaction.ConceptosTransacciones.map((concepto: any) => concepto.Importe || 0)
    ).reduce((acc, importe) => acc + importe, 0);
  }, [FilteredTransactions]);
  

  
  const chartData = useMemo(() => {
    return {
      labels: ['Total Importe'],
      datasets: [
        {
          label: 'Importe total de conceptos',
          data: [totalImporte],
          backgroundColor: 'rgba(75, 192, 192, 0.6)',
          borderColor: 'rgba(75, 192, 192, 1)',
          borderWidth: 1,
        },
      ],
    };
  }, [totalImporte]);
  
  
  

  const handleViewDetails = useCallback(
    (transaction: Transaccion) => {
      setSelectedTransaction(transaction);
      onDetailOpen();
    },
    [onDetailOpen],
  );
  const downloadExcel = useCallback(() => {
    // Aplanar los datos para que cada concepto tenga sus propias filas
    const flattenedData = FilteredTransactions.flatMap(transaction =>
      transaction.ConceptosTransacciones.map(concepto => ({
        "ID Factura": transaction.ID, // Número original
        "ID Transacción": transaction.IDTransacc,
        "Descripción": concepto.Descripcion,
        "Cantidad": concepto.Cantidad || 0,
        "Valor Unitario": concepto.ValorUnitario ? parseFloat(concepto.ValorUnitario.toFixed(2)) : 0, // Sin $
        "Importe": concepto.Importe ? parseFloat(concepto.Importe.toFixed(2)) : 0 // Sin $
      }))
    );

    // Calcular los totales
    const totalCantidad = flattenedData.reduce((acc, row) => acc + row["Cantidad"], 0);
    const totalValorUnitario = flattenedData.reduce((acc, row) => acc + row["Valor Unitario"], 0);
    const totalImporte = flattenedData.reduce((acc, row) => acc + row["Importe"], 0);

    // Agregar la fila de totales (con "ID Factura" como string)
    flattenedData.push({
        "ID Factura": "", // Convertido a string
        "ID Transacción": "",
        "Descripción": "",
        "Cantidad": totalCantidad,
        "Valor Unitario": totalValorUnitario.toFixed(2), // Muestra el total con 2 decimales
        "Importe": totalImporte.toFixed(2) // Muestra el total con 2 decimales
    } as any); // Forzar como 'any' solo en esta línea para evitar errores de tipo

    // Crear la hoja de cálculo
    const ws = XLSX.utils.json_to_sheet(flattenedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Transacciones');

    // Descargar el archivo
    XLSX.writeFile(wb, 'transacciones.xlsx');
}, [FilteredTransactions]);


  

  return (
    <Box p={5}>
                  <LoadingOverlay isLoading={isLoading} message="Procesando..." />

      {loading && (
        <Box
          position="fixed"
          top="0"
          left="0"
          width="100vw"
          height="100vh"
          bg="rgba(0, 0, 0, 0.5)"
          display="flex"
          justifyContent="center"
          alignItems="center"
          zIndex="9999"
        >
          <Spinner size="xl" color="white" />
        </Box>
      )}
      <Heading mb={6} textAlign="center">
        Historial de Transacciones
      </Heading>

      {/* Gráfica */}
      <Box
        mb={6}
        style={{
          maxWidth: '600px',
          maxHeight: '400px',
          margin: '0 auto',
        }}
      >
        <Bar data={chartData} options={chartOptions} />
      </Box>

      {/* Filtros y Acciones */}
      <Flex justifyContent="space-between" mb={2}>
        <Grid templateColumns="repeat(6, 3fr)" gap={1}>
          <Input
            placeholder="Filtrar por Descripcion"
            value={razonSocialFilterx}
            maxW={'780px'}
            onChange={(e) => setRazonSocialFilterx(e.target.value)} // Actualiza el estado al escribir
            focusBorderColor="teal.400" // Color del borde cuando está enfocado
            size="md" // Tamaño del input
            variant="outline" // Estilo del input
          />

          <Input
            placeholder="Filtrar por ID Transacción"
            value={usuarioFilterx}
            maxW={'480px'}
            onChange={(e) => setusuarioFilterx(e.target.value)} // Actualiza el estado al escribir
            focusBorderColor="teal.400" // Color del borde cuando está enfocado
            size="md" // Tamaño del input
            variant="outline" // Estilo del input
          />
          {/* Checkbox controlado */}
          <Select
            placeholder="Selecciona un Estado"
            value={estatusFilter} // Valor actual del filtro
            onChange={(e) => setEstatusFilter(e.target.value)} // Actualiza el estado al cambiar
            colorScheme="teal"
            size="md"
            maxW="320px"
          >
            <option value="">Todos</option>
            <option value="CANCELADO">CANCELADO</option>
            <option value="TIMBRADOS">TIMBRADOS</option>
          </Select>

          <Select
            placeholder="Selecciona un Area"
            value={estatusFilter} // Valor actual del filtro
            onChange={(e) => setConceptoFilter(e.target.value)} // Actualiza el estado al cambiar
            colorScheme="teal"
            size="md"
            maxW="320px"
          >
            <option value="">Todos</option>
            <option value="PREDIAL">PREDIAL</option>
            <option value="GENERAL">GENERAL</option>
            <option value="AGUA POTABLE">AGUA POTABLE</option>
          </Select>

          <Input
            type="date"
            placeholder="Desde"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <Input
            type="date"
            placeholder="Hasta"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
    <Button colorScheme="teal" onClick={applyFilters}>
    Aplicar Filtros
  </Button>

        </Grid>

        <HStack spacing={4}>
          <Menu>
            {user.rol == 'A1' && (
              <MenuButton
                as={Button}
                rightIcon={<ChevronDownIcon />}
                colorScheme="yellow"
              >
                Reportes
              </MenuButton>
            )}
            <MenuList>
              <MenuItem onClick={downloadExcel}>Descargar XLS</MenuItem>
            </MenuList>
          </Menu>
        </HStack>
      </Flex>

      {/* Tabla de Transacciones */}
      <Box overflowY="auto">
        <Table size="sm" variant="simple">
          <Thead>
            <Tr>
              <Th># Factura</Th>
              <Th>ID Transacción</Th>
              <Th>Descripción</Th>
              <Th>Cantidad</Th>
              <Th>Valor Unitario</Th>
              <Th>Importe</Th>
            </Tr>
          </Thead>
          <Tbody>
            {FilteredTransactions.flatMap((transaction: any) =>
              transaction.ConceptosTransacciones.map(
                (concepto: any, index: number) => (
                  <Tr key={`${transaction.ID}-${concepto.ID}`}>
                    {/* Solo muestra el ID y el IDTransacc en la primera fila de cada transacción */}
                    {index === 0 ? (
                      <>
                        <Td rowSpan={transaction.ConceptosTransacciones.length}>
                          {transaction.ID}
                        </Td>
                        <Td rowSpan={transaction.ConceptosTransacciones.length}>
                          {transaction.IDTransacc}
                        </Td>
                      </>
                    ) : null}

                    {/* Datos del concepto en la misma fila */}
                    <Td>{concepto.Descripcion}</Td>
                    <Td>{concepto.Cantidad}</Td>
                
                    <Td>{`$${concepto.ValorUnitario.toFixed(2)}`}</Td>
                    <Td>{`$${concepto.Importe.toFixed(2)}`}</Td>
                  </Tr>
                ),
              ),
            )}
          </Tbody>
        </Table>
      </Box>

      {/* Paginación */}
      <Flex justifyContent="space-between" mt={4}>
        <Button
          onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
          isDisabled={page === 1}
        >
          Anterior
        </Button>
        <Text>
          Página {page} de {totalPages}
        </Text>
        <Button
          onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
          isDisabled={page === totalPages}
        >
          Siguiente
        </Button>
      </Flex>
    </Box>
  );
};

export default HistorialTransacciones;
